import Cookies from 'js-cookie';

const url=process.env.REACT_APP_ENV==="production"?"https://hrmanagement.zorvas.com":process.env.REACT_APP_API_URL

async function MobileLogin(userData)
{
    const phoneNumber=userData;

    try
    {
        const response=await fetch(`${url}/api/otp/send-otp-login`,{method:'POST',headers:{'Content-Type':"application/json"},
            body:JSON.stringify({"phoneNumber":phoneNumber})});

        if(response.ok)
        {
            const data=await response.json();
            return data;
        }
        else
        {
            const data = await response.json();
            if (response.status === 400) {
                return data.message || "Phone number is required!";
            } 
            else if (response.status === 404) {
                return data.message || "user not found!";
            } 
            else {
                return "Something went wrong. Please try again.";
            }
        }

    }
    catch(error)
    {
        console.log(error);
    }
}

async function MobileRegister(userData)
{
    const phoneNumber=userData;
    try
    {
        const response=await fetch(`${url}/api/otp/send-otp-register`,{method:'POST',headers:{'Content-Type':"application/json"},
            body:JSON.stringify({"phoneNumber":phoneNumber})});

        if(response.ok)
        {
            const data=await response.json();
            return data;
        }
        else
        {
            const data = await response.json();
            if (response.status === 400) {
                return data.message || "Phone number is required!";
            } 
            else if (response.status === 409) {
                return data.message || "user already registered!";
            } 
            else {
                return "Something went wrong. Please try again.";
            }
        }

    }
    catch(error)
    {
        return { success: false, message: "A network error occurred. Please check your connection and try again." };
    }
}

async function MobileVerify(userData)
{
    const {phoneNumber,otp}=userData;
    
    console.log(phoneNumber,otp)
    try
    {
        const response=await fetch(`${url}/api/otp/verify-otp`,{method:'POST',headers:{'Content-Type':"application/json"},
            body:JSON.stringify({"phoneNumber":phoneNumber,"otp":otp})});

        if(response.ok)
        {
            const data=await response.json();

            const {token}=data;
            console.log(data);
            Cookies.set("token",token,{secure:true,sameSite:'strict'});

            return data;
        }
        else
        {
            const data = await response.json();
            if (response.status === 400) {
                return data.message || "Invalid Otp";
            } 
            else {
                return "Something went wrong. Please try again.";
            }
        }

    }
    catch(error)
    {
        return { success: false, message: "A network error occurred. Please check your connection and try again." };
    }
}


export { MobileLogin,MobileVerify,MobileRegister};